<div class="flex flex-col items-center jumpbox-msg p-12">
  <div class="flex flex-row items-center">
    <div class="icon-oval mr-16">
      <mat-icon *ngIf="pageName === 'jumpbox'" svgIcon="warning" class="icon-md jumpbox-warning"></mat-icon>
      <mat-icon *ngIf="pageName === 'schedule'" svgIcon="info" class="icon-md schedule-info"></mat-icon>
    </div>
    <div class="flex flex-row items-center">{{(pageName==='schedule' ? 'SCHEDULES.CHECK_SCHEDULE': 'JUMPBOX.CHECK_JUMPBOX') | transloco }} &nbsp; &nbsp;
      <button class="white h-34 fw-100 mr-20 cursor-pointer" type="button" (click)="pageName==='schedule' ? navigateToSchedule() : moveToJumpbox()"> {{ (pageName==='schedule' ? 'SCHEDULES.VIEW_SCHEDULE' : 'JUMPBOX.VIEW_JUMPBOX') | transloco }}
      </button>
      <mat-icon svgIcon="close" class="icon-md cursor-pointer" (click)="closeToast()"></mat-icon>
    </div>
  </div>
</div>